import { EnumSchema } from '../metadata-schema';

export const Instroomtype: EnumSchema = {
	"type": "string",
	"title": "Instroomtype",
	"enum": [
		"Intern",
		"Extern"
	]
};
